import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrHamburgerIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M2.90039 4.4002C2.90039 4.0002 3.20039 3.7002 3.60039 3.7002H12.5004C12.9004 3.7002 13.2004 4.0002 13.2004 4.4002C13.2004 4.8002 12.9004 5.1002 12.5004 5.1002H3.60039C3.20039 5.1002 2.90039 4.8002 2.90039 4.4002ZM12.4004 7.3002H3.60039C3.20039 7.3002 2.90039 7.6002 2.90039 8.0002C2.90039 8.4002 3.20039 8.7002 3.60039 8.7002H12.5004C12.9004 8.7002 13.2004 8.4002 13.2004 8.0002C13.2004 7.6002 12.8004 7.3002 12.4004 7.3002ZM12.4004 10.9002H3.60039C3.20039 10.9002 2.90039 11.2002 2.90039 11.6002C2.90039 12.0002 3.20039 12.3002 3.60039 12.3002H12.5004C12.9004 12.3002 13.2004 12.0002 13.2004 11.6002C13.2004 11.2002 12.8004 10.9002 12.4004 10.9002Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrHamburgerIconComponent;
